module.exports = __webpack_public_path__ + "media/soundtrack.be2ca87b.mp3";